<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ReportView',
  mounted() {
    this.$store.state.tabs = [
      {
        'text': this.$t('reports_and_requests'),
        'to': this.$router.currentRoute.value.meta.team === 'admin' ? '/request' : '/operator/report'
      },
    ]
  }
}
</script>
